import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {RoadKill} from "../RoadKill";
import {gsap, TimelineLite} from "gsap";
import {JW_TYPE, SYMBOL_NAME} from "../component/enums/RoadKillEnums";
import {ISpecialSymData, RoadKillGameData} from "../server/RoadKillData";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {RoadKillSound} from "../sound/RoadKillSound";
import {RoadKillGameMode} from "../server/RoadKillGameMode";

export class JumpingWildRunner implements SimplePresentation {
    private playTriggerOnceFlag: boolean = true;
    private _tl: TimelineLite;

    shouldRun(): boolean {
        return RoadKill.model.gameData.specialSymbolList.length > 1;
    }

    start(controller: SimplePresentationRunnerController): void {
        controller.setSkipCallback(() => this.onSkip());
        this._tl = new TimelineLite();
        this.playTriggerOnceFlag = true;
        let animalRevealSoundOnce: boolean = true,
            posterSoundOnce: boolean = true;
        const gameData: RoadKillGameData = RoadKill.model.gameData,
            updateTopHitsTl: TimelineLite = new TimelineLite(),
            isLuckyDraw: boolean = gameData.isLuckyDraw && gameData.wasFeatureBuy;
        const topHeadRabbitPopInAnim: TimelineLite = new TimelineLite();
        const topHeadDeerPopInAnim: TimelineLite = new TimelineLite();
        const topHeadBearPopInAnim: TimelineLite = new TimelineLite();

        RoadKill.model.gameData.specialSymbolList.forEach((specialSymData: ISpecialSymData) => {
            if (!specialSymData.coordTo) {
                let topHeadPopInAnim: TimelineLite;
                this._tl.add([RoadKill.jumpingWildView.onLand(specialSymData), this.playTriggerSound()], 0);
                this._tl.add(() => {
                    RoadKillUtils.getSymbol(specialSymData.coordFrom[0], specialSymData.coordFrom[1]).changeSymbol(specialSymData.symName as SYMBOL_NAME);
                });
                if (RoadKillUtils.getJWType(specialSymData.symName) === JW_TYPE.RABBIT) {
                    topHeadPopInAnim = topHeadRabbitPopInAnim;
                } else if (RoadKillUtils.getJWType(specialSymData.symName) === JW_TYPE.DEER) {
                    topHeadPopInAnim = topHeadDeerPopInAnim;
                } else {
                    topHeadPopInAnim = topHeadBearPopInAnim;
                }
                //ladning all animals Normal to SFS- bonus buy
                if (this.allAnimalsLanded() && RoadKill.topAnimalController.isSuperFS()) {
                    topHeadPopInAnim.add(RoadKill.topAnimalController.getJWPopInAnim(RoadKillUtils.getJWType(specialSymData.symName), true, animalRevealSoundOnce));//, "-=0.2");
                }
                //when Normal to FS or Respin is triggered
                else if (gameData.mode === RoadKillGameMode.NORMAL && (gameData.nextMode === RoadKillGameMode.FREESPIN || gameData.nextMode === RoadKillGameMode.RESPIN)) {
                    topHeadPopInAnim.add(RoadKill.topAnimalController.getJWPopInAnim(RoadKillUtils.getJWType(specialSymData.symName), specialSymData.upgraded, animalRevealSoundOnce));
                }
                //when third animal lands in Respin case
                else if (gameData.mode === RoadKillGameMode.RESPIN && gameData.nextMode === RoadKillGameMode.FREESPIN) {
                    topHeadPopInAnim.add(RoadKill.topAnimalController.getJWPopInAnim(RoadKillUtils.getJWType(specialSymData.symName), specialSymData.upgraded, animalRevealSoundOnce));
                }

                if (isLuckyDraw && specialSymData.upgraded) {
                    updateTopHitsTl.add(RoadKill.topAnimalController.updateTopAnimalHits(specialSymData.symName as SYMBOL_NAME, specialSymData.getHitCount, false, true));
                }
                animalRevealSoundOnce = false;
            }
        });

        if (!RoadKill.model.brokeTheBank) {
            this._tl.add(() => {
                RoadKill.lifeView.update(RoadKill.model.gameData.heartList);
            });
        }
        let topHeadPopInAnim: TimelineLite = new TimelineLite();
        let counter: number = 0;
        if (topHeadRabbitPopInAnim.totalDuration() > 0) {
            topHeadPopInAnim.add(topHeadRabbitPopInAnim, counter * 0.3);
            counter++;
        }
        if (topHeadDeerPopInAnim.totalDuration() > 0) {
            topHeadPopInAnim.add(topHeadDeerPopInAnim, counter * 0.3);
            counter++;
        }
        if (topHeadBearPopInAnim.totalDuration() > 0) {
            topHeadPopInAnim.add(topHeadBearPopInAnim, counter * 0.3);
        }
        if(counter > 0){
            this._tl.add(topHeadPopInAnim, this._tl.totalDuration() > 1 ? 2 : 0); //#219
        }
        this._tl.add(updateTopHitsTl); //#219

        if (this._tl.duration() == 0) {
            this._tl.add(gsap.to(this, {duration: 0.001}));
        }
        this._tl.add(() => {
            controller.finish();
        });
    }

    private allAnimalsLanded(): boolean {
        RoadKill.model.specialSymLandingArray.forEach((data) => {
            if (data.coordTo) return false;
        })
        return true;
    }

    private onSkip(): void {
        this._tl.timeScale(2);
    }


    private playTriggerSound(): TimelineLite {
        return new TimelineLite().add(() => {
            if (this.playTriggerOnceFlag) {
                RoadKill.soundPlayer.playTrack(RoadKillSound.SCATTER_TRIGGER);
                this.playTriggerOnceFlag = false;
            }
        });
    }

}
